export class QuantitySelector {
  constructor() {
    this.total = 1;
    this.value_display = document.getElementById("quantity-selector-value");
    this.controls = {
      add: document.getElementById("quantity-selector-add"),
      subtract: document.getElementById("quantity-selector-subtract"),
    };
  }

  _increase = () => {
    if (this.total < 99) {
      this.total = this.total + 1;
      this.value_display.value = this.total;
    }
  };

  _decrease = () => {
    if (this.total > 1) {
      this.total = this.total - 1;
      this.value_display.value = this.total;
      this.value_display.setAttribute("aria-valuenow", this.total);
    }
  };

  _init = () => {
    if (this.value_display !== undefined) {
      this.controls.add.addEventListener("click", this._increase);
      this.controls.subtract.addEventListener("click", this._decrease);
    }
  };
}
